// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @04.09.2017 15:41:07
import { ICustomerSpecificsResult_abstract } from './../../abstract/SagaBase/Interfaces/ICustomerSpecificsResult_abstract';
export class ICustomerSpecificsResult extends ICustomerSpecificsResult_abstract {}
